import { createFileRoute } from "@tanstack/react-router";
import {
  Hero,
  ValueProps,
  ServicesTeaser,
  WhyChooseUs,
  Process,
  StampedShowcase,
  FeaturedWork,
  Testimonials,
  HomeFAQ,
  FinalCTA,
} from "#/components/pages/home";
import { getFAQSchema, getWebSiteSchema } from "#/lib/seo";
import { HERO_DESKTOP, HERO_MOBILE } from "#/lib/images";

export const Route = createFileRoute("/")({
  head: () => ({
    meta: [
      { title: "Blue Rock Concrete | Concrete Contractor in Wilmington, DE" },
      {
        name: "description",
        content:
          "Concrete driveways, patios, stamped concrete, repair & epoxy floors in Wilmington, DE. Licensed, bonded & insured. Free same-week estimates. Built for Delaware winters.",
      },
      { property: "og:url", content: "https://bluerockconcreteco.com/" },
    ],
    links: [
      { rel: "canonical", href: "https://bluerockconcreteco.com/" },
      {
        rel: "preload",
        as: "image",
        href: HERO_MOBILE,
        fetchPriority: "high",
        media: "(max-width: 767px)",
      },
      {
        rel: "preload",
        as: "image",
        href: HERO_DESKTOP,
        fetchPriority: "high",
        media: "(min-width: 768px)",
      },
    ],
    scripts: [
      { type: "application/ld+json", children: JSON.stringify(getWebSiteSchema()) },
      // FAQPage moved here with the FAQ itself when /reviews was mothballed.
      // It must be emitted from exactly one route — /reviews no longer does.
      { type: "application/ld+json", children: JSON.stringify(getFAQSchema()) },
    ],
  }),
  component: HomePage,
});

function HomePage() {
  return (
    <main>
      <Hero />
      <ValueProps />
      <ServicesTeaser />
      <WhyChooseUs />
      <Process />
      <StampedShowcase />
      <FeaturedWork />
      <Testimonials />
      {/* Back on the home page since /reviews was mothballed — it was the only
          place the FAQ (and its FAQPage schema) lived. */}
      <HomeFAQ />
      <FinalCTA />
    </main>
  );
}
